/*
 * Copyright (c) 2021 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@material-ui/core";
import React from "react";

interface ApplicationErrorFallbackProps {
    error?: Error;
    resetErrorBoundary?: () => void;
}

export default function ApplicationErrorFallback({ error, resetErrorBoundary }: ApplicationErrorFallbackProps) {
    return (
        <Dialog open maxWidth="xs">
            <DialogContent>
                <Typography variant="h1">Unexpected error has occurred</Typography>
                {error && (
                    <Box py={2}>
                        <pre>{error.message}</pre>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={resetErrorBoundary}>Try Again</Button>
            </DialogActions>
        </Dialog>
    );
}
